import React from "react";
import { Text } from "react-native-paper";
import {
  BooleanCheckboxDisplayRenderer,
  ChatDisplayRenderer,
  ChecklistDisplayRenderer,
  CollectionPickerDisplayRenderer,
  ColorDisplayRenderer,
  DropdownLikeDisplayRenderer,
  FieldDisplayRendererComponent,
  FileDisplayRenderer,
  LocationDisplayRenderer,
  MechanicLikeDisplayRenderer,
  ObjectDisplayRenderer,
  OtpDisplayRenderer,
  PaymentsFormDisplayRenderer,
  RatingDisplayRenderer,
  ReferenceDisplayRenderer,
  RichTextDisplayRenderer,
  SignatureDisplayRenderer,
  SimpleValueDisplayRenderer,
  StatusDisplayRenderer,
  FieldDisplayRendererProps,
  WarehouseItemsPickerDisplayRenderer,
} from "./displayRenderers";

const UnsupportedFieldDisplayRenderer = ({
  field,
}: FieldDisplayRendererProps) => {
  return <Text>{`Unsupported type: ${field.type}`}</Text>;
};

export const fieldDisplayRegistry: Record<
  string,
  FieldDisplayRendererComponent
> = {
  text: SimpleValueDisplayRenderer,
  password: SimpleValueDisplayRenderer,
  textarea: SimpleValueDisplayRenderer,
  number: SimpleValueDisplayRenderer,
  phone: SimpleValueDisplayRenderer,
  url: SimpleValueDisplayRenderer,
  email: SimpleValueDisplayRenderer,
  datePicker: SimpleValueDisplayRenderer,
  dateTime: SimpleValueDisplayRenderer,
  dateTimeNoYear: SimpleValueDisplayRenderer,
  calculated: SimpleValueDisplayRenderer,
  numberId: SimpleValueDisplayRenderer,
  status: StatusDisplayRenderer,
  segmentedButtons: DropdownLikeDisplayRenderer,
  dropdown: DropdownLikeDisplayRenderer,
  collectionPicker: CollectionPickerDisplayRenderer,
  paymentsForm: PaymentsFormDisplayRenderer,
  mechanicPicker: MechanicLikeDisplayRenderer,
  testPicker: MechanicLikeDisplayRenderer,
  warehouseItemsPicker: WarehouseItemsPickerDisplayRenderer,
  file: FileDisplayRenderer,
  fileAndDocument: FileDisplayRenderer,
  document: FileDisplayRenderer,
  booleanCheckbox: BooleanCheckboxDisplayRenderer,
  reference: ReferenceDisplayRenderer,
  rating: RatingDisplayRenderer,
  color: ColorDisplayRenderer,
  location: LocationDisplayRenderer,
  otp: OtpDisplayRenderer,
  signature: SignatureDisplayRenderer,
  markdown: RichTextDisplayRenderer,
  richText: RichTextDisplayRenderer,
  object: ObjectDisplayRenderer,
  checklist: ChecklistDisplayRenderer,
  chat: ChatDisplayRenderer,
};

export const getFieldComponent = (
  fieldType: string,
): FieldDisplayRendererComponent => {
  return fieldDisplayRegistry[fieldType] || UnsupportedFieldDisplayRenderer;
};
